import apiClient from '../api-client';
import type { Store } from '@geely/shared';

export const storesApi = {
  list: () => apiClient.get<Store[]>('/stores'),

  getById: (id: string) => apiClient.get<Store>(`/stores/${id}`),
};
